import InboomaBaseModel from "./InboomaBaseModel";

export default InboomaBaseModel.extend({
  defaults: {
    id: "",
    client: null,
    client_id: "",
    name: "",
    description: "",
    created: "",
    modified: "",
    deleted: "",
  },
});
